import { render, staticRenderFns } from "./AppSettingsEmailPreferences.vue?vue&type=template&id=6c42bfb9&scoped=true&"
import script from "./AppSettingsEmailPreferences.vue?vue&type=script&lang=js&"
export * from "./AppSettingsEmailPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsEmailPreferences.vue?vue&type=style&index=0&id=6c42bfb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42bfb9",
  null
  
)

export default component.exports